import { render, staticRenderFns } from "./assist-case.vue?vue&type=template&id=25f94a18"
import script from "./assist-case.vue?vue&type=script&lang=ts"
export * from "./assist-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports